export const ROUTES = {
  HOME: "/",
  ABOUT: "/about",
  SPORTS: "/sports/:id",
  FOOTBALL: "/football",
  BASKETBALL: "/basketball",
  TRACK: "/track",
  FACILITY: "/the-facility",
  TEAM: "/the-team",
  CONTACT: "/contact",
  DONATE: "/donate",
  TEAM_MEMBER_DETAIL: "/team/:id",
  OUR_MISSION: "/our-mission",
  FORM: "/form",
  COLLABORATE: "/collaborate",
  INDEMNITY_AGREEMENT: "/indemnity-agreement",
  CODE_OF_CONDUCT: "/code-of-conduct",
  SQUARE_SERVICES: "/square-services",
};
